export default __webpack_public_path__ + "static/media/apple.e68a9082.jfif";